import { z } from 'zod';
import { firestoreTimestampSchema } from './user'; // Re-use from user.ts

const businessResultSchema = z.object({
  customerId: z.string().optional(), // Optional as it's missing in failed cases
  status: z.enum(['success', 'failed']),
  error: z.string().optional(),
}).passthrough();

export const adSyncHistorySchema = z.object({
  date: z.string(), // Assuming "YYYY-MM-DD" format
  createdAt: firestoreTimestampSchema,
  startTime: firestoreTimestampSchema,
  endTime: firestoreTimestampSchema,
  totalBusinesses: z.number().int(),
  successfulSyncs: z.number().int(),
  failedSyncs: z.number().int(),
  status: z.string(), // e.g., "completed"
  businessResults: z.record(businessResultSchema).optional().nullable(), // Keys are business IDs (UUIDs)
}).passthrough();

export type AdSyncHistory = z.infer<typeof adSyncHistorySchema>;
